import { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

import { RootLayout } from "@/components/layout/RootLayout";
import { AboutPage } from "@/features/about/AboutPage";
import { AiGatePage } from "@/features/ai/AiGatePage";
import { AppPage } from "@/features/app/AppPage";
import { LandingPage } from "@/features/landing/LandingPage";
import { RestorePage } from "@/features/restore/RestorePage";

// Code-split the layout viewer (and its Motion/animation deps) so it loads
// only when the /layout route is visited, keeping the main bundle lean.
const LayoutViewerPage = lazy(() =>
  import("@/features/layout/LayoutViewerPage").then((m) => ({ default: m.LayoutViewerPage })),
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: "app", element: <AppPage /> },
      {
        path: "layout",
        element: (
          <Suspense
            fallback={
              <div className="px-4 py-16 text-center text-sm text-[var(--color-ink-muted)]">
                読み込み中…
              </div>
            }
          >
            <LayoutViewerPage />
          </Suspense>
        ),
      },
      { path: "restore", element: <RestorePage /> },
      { path: "ai", element: <AiGatePage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
]);
